
import { defineComponent, computed, unref } from '@vue/composition-api';
import { useActions, useState } from 'vuex-composition-helpers';
import { IMapForFiltersSerpActions, IMapForFiltersSerpState } from '@fr/vue/components/searchFilters/store/types';
import FilterListRender from '@ve/components/filters/common/components/FilterListRender/FilterListRender.vue';
import FilterPostWrapper from '@ve/components/searchFilters/filterList/desktop/FilterPostWrapper.vue';
import FiltersListSection from '@ve/components/searchFilters/filterList/desktop/FiltersListSection.vue';
import { IBeachLine } from '@fr/vue/components/filters/beachLineFilter/types';
import useFilterAttributesAnalytics from '@ve/components/filters/common/use/useFilterAttributesAnalytics';
import useLogicRestType from '@ve/components/filters/common/use/useLogicRestType';
import { nameFilterSerpStore } from '@ve/components/searchFilters/store/getFiltersSerpStore';
import filterAttributesMethodsBeachType from './filterAttributeMethods/FilterAttributeMethodsBeachType';

export default defineComponent({
    components: {
        FilterListRender,
        FilterPostWrapper,
        FiltersListSection,
    },
    setup() {
        const {
            takenBeachType, filteredHotelsWithoutBeachType, syncHotels, isPopularityFilterActive,
        } = useState<IMapForFiltersSerpState>(nameFilterSerpStore, ['takenBeachType', 'filteredHotelsWithoutBeachType', 'syncHotels', 'isPopularityFilterActive']);
        const { action_takenBeachType: setBeachType } = useActions<IMapForFiltersSerpActions>(nameFilterSerpStore, ['action_takenBeachType']);

        const selectedBeachTypes = computed({
            get: () => unref(takenBeachType),
            set: (value: IBeachLine['id'][]) => setBeachType(value),
        });

        return {
            selectedBeachTypes,
            filteredHotelsWithoutBeachType,
            syncHotels,
            filterAttributesMethodsBeachType,
            isPopularityFilterActive,
            ...useLogicRestType(filterAttributesMethodsBeachType),
            ...useFilterAttributesAnalytics(filterAttributesMethodsBeachType, { typeEvent: 'beachType', nameAnyEventEng: '', nameAnyEventRu: 'тип пляжа_Любой' }),
        };
    },
});
